import { fromJS } from 'immutable';
import shortid from 'shortid';

import {
  LOAD_INFLUENCERS,
  LOAD_INFLUENCERS_SUCCESS,
  LOAD_INFLUENCERS_ERROR,
  LOAD_SINGLE_INFLUENCER,
  LOAD_SINGLE_INFLUENCER_SUCCESS,
  LOAD_SINGLE_INFLUENCER_ERROR,
  SEARCH,
  SEARCH_SUCCESS,
  SEARCH_ERROR,
  ADD_INFLUENCER,
  ADD_INFLUENCER_SUCCESS,
  ADD_INFLUENCER_EROR,
  LOAD_ORGANISATION_NAME_SUCCESS,
  LOAD_ORGANISATION_NAME_ERROR,
} from './constants';

const initialState = fromJS({
  data: null,
  singleData: null,
  error: null,
  success: null,
  loading: false,
  add: false,
  count: 0,
  searchData: null,
  searchError: null,
  searchLoading: false,
  organisationName: null,
});


function influencersReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_INFLUENCERS:
    return state
      .set('data', null)
      .set('loading', true)
      .set('count', 0);
  case LOAD_INFLUENCERS_SUCCESS:
    return state
      .set('data', action.data)
      .set('error', null)
      .set('loading', false)
      .set('count', action.count);
  case LOAD_INFLUENCERS_ERROR:
    return state
      .set('loading', false)
      .set('error', action.data)
      .set('count', 0);
  case LOAD_SINGLE_INFLUENCER:
    return state
      .set('data', null)
      .set('loading', true);
  case LOAD_SINGLE_INFLUENCER_SUCCESS:
    return state
      .set('singleData', action.data)
      .set('error', null)
      .set('loading', false);
  case LOAD_SINGLE_INFLUENCER_ERROR:
    return state
      .set('loading', false)
      .set('error', action.data);
  case SEARCH:
    return state
      .set('searchData', null)
      .set('searchLoading', true);
  case SEARCH_SUCCESS:
    return state
      .set('searchData', action.data)
      .set('searchError', null)
      .set('searchLoading', false);
  case SEARCH_ERROR:
    return state
      .set('searchError', action.data)
      .set('searchLoading', false);
  case ADD_INFLUENCER:
    return state
      .set('loading', true);
  case ADD_INFLUENCER_SUCCESS:
    {
      const cachebuster = shortid.generate();
      window.location.assign(`/influencers?cb=${cachebuster}`);
      return state
        .set('loading', false)
        .set('success', 'Your new influencer has been successfully added!')
        .set('error', null);
    }
  case ADD_INFLUENCER_EROR:
    return state
      .set('loading', false)
      .set('error', action.data);
  case LOAD_ORGANISATION_NAME_SUCCESS:
    return state
      .set('organisationName', action.data);
  case LOAD_ORGANISATION_NAME_ERROR:
    return state
      .set('organisationName', 'Organisation Name Load Error');
  default:
    return state;
  }
}

export default influencersReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/influencers/reducer.js
 **/